<template>
  <svg width="19" height="19" viewBox="0 0 19 19" fill="none">
    <g clip-path="url(#clip0_2131_6054)">
      <path
        d="M3.53784 11.5846L3.53784 3.14734L11.9751 3.14734V7.676C12.4655 7.51991
      12.9771 7.47439 13.4751 7.53264V3.14734C13.4751 2.31891 12.8035 1.64734
      11.9751 1.64734L3.53784 1.64734C2.70941 1.64734 2.03784 2.31891 2.03784
      3.14734L2.03784 11.5846C2.03784 12.413 2.70942 13.0846 3.53784
      13.0846H10.0831C9.771 12.6184 9.58279 12.1055 9.51083
      11.5846H3.53784Z"
        fill="#A2B1C6"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M14.7887 9.9291C15.4307 10.8837 15.1773 12.1779 14.2228
      12.8199C13.2682 13.4618 11.974 13.2084 11.332 12.2539C10.69 11.2993
      10.9434 10.0051 11.898 9.3631C12.8525 8.72113 14.1468 8.97454 14.7887
      9.9291ZM14.4606 14.3901L16.6181 17.5982C16.8492 17.9419 17.3153 18.0331
      17.659 17.802C18.0027 17.5708 18.0939 17.1048 17.8628 16.7611L15.6884
      13.5279C16.7949 12.3365 16.9801 10.4996 16.0334 9.092C14.9292 7.45002
      12.7029 7.01412 11.0609 8.1184C9.41891 9.22268 8.98302 11.449 10.0873
      13.0909C11.062 14.5403 12.9109 15.05 14.4606 14.3901Z"
        fill="#A2B1C6"
      />
    </g>
    <defs>
      <clipPath id="clip0_2131_6054">
        <rect
          width="18"
          height="18"
          fill="white"
          transform="translate(0.5 18.5916) rotate(-90)"
        />
      </clipPath>
    </defs>
  </svg>
</template>

<script>
export default {
  name: 'ViewCellValueIcon'
}
</script>
